import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Họ và tên:", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Email:", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Thêm tài khoản email nhận:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký email vào danh sách chỉ đạo tuyến " }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            id: "fullname",
            type: "text",
            modelValue: $setup.emailDetail.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.emailDetail.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            id: "email",
            type: "text",
            modelValue: $setup.emailDetail.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.emailDetail.email) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Button, {
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.doRegister())),
            disabled: !$setup.valid()
          }, null, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}